import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero.jsx";
import banner from "./assets/images/banner.png";
import Features from "./components/Features.jsx";
import WhyUs from "./components/WhyUs";
import WhyUsDark from "./components/WhyUsDark";
import Mission from "./components/Mission";
import CTA from "./components/CTA";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <div
        className="bg-cover bg-center min-h-[70vh] sm:min-h-[75vh] md:min-h-[85vh] lg:min-h-[90vh]"
        style={{
          backgroundImage: `url(${banner})`,
        }}
      >
        <Header />
        <Hero />
      </div>
      <div className="relative -mt-64 z-10 px-4 sm:px-6 md:px-16 lg:px-32">
        <Features />
      </div>
      <WhyUs />
      <WhyUsDark />
      <Mission />
      <div className="px-4 sm:px-6 md:px-16 lg:px-32">
        <CTA />
      </div>
      <div
        className="bg-cover min-h-[40vh] relative -mt-36 -z-10"
        style={{
          backgroundImage: `url(${banner})`,
        }}
      >
        <div className="relative pt-64 z-10">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default App;
